// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__36Fk8","fullScreen":"style_fullScreen__2Tz_M","hidden":"style_hidden__3HIe5","transparent":"style_transparent__2Asgq"};